import { Component, OnInit , Inject, AfterViewInit, OnDestroy} from '@angular/core';
import { ISubscription } from "rxjs/Subscription";
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Http } from '@angular/http';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../common/shared.service';
import { PortalService } from '../services/portal.service';
import { TopnavService } from '../header/topnav/topnav.service';

/* Author: Sridhar Swaminathan
* 
* Date Created: November 14th 2017
* 
* Description: Component class for poll
**/
@Component({
  selector: 'app-poll',
  templateUrl: './poll.component.html',
  styleUrls: ['./poll.component.css']
})
export class PollComponent implements OnInit, AfterViewInit, OnDestroy {
    public idx;
    private pollDataSet = [];
    pollDataTitle: string;
    pollDataQuestion: string;
    pollDataQuestionID;
    pollDataAnswer: any;
    pollDataComment: string;
    pollComment = '';
    pollAnswer: any;
    lang = 'en';
    filter= false;
    private pollUrl: string = this.config.urlPoll;
    // showResult = false;
    showResult;
    latestResult = false;
    value = 50;
    ipData: any;
    dumy = '#0000';
    resultData: any;
    languageId = this.languageId;
    pollPercent;
    progressbarVal;
    pollReference;
    lengthPoll = 0; 
    flagSend = false;
    private subscriptionLang: ISubscription;
    private subscription: ISubscription;
    public browserLang: string;
    
    public subscriptionFontType: ISubscription;
    public fontType: string = 'Arial';
    private subscriptionFontSize: ISubscription;

    public fontSize: any = {
      "sizeS" : "14px",
      "sizeM" : "19px",
      "sizeL" : "23px",
      "no_styles" : "0.9em"
    };

    private isInitialized: boolean = false;

    constructor(private translate: TranslateService,private topnavservice: TopnavService, private http: Http, @Inject(APP_CONFIG) private config: AppConfig, private toastr: ToastrService, private sharedService: SharedService, private portalservice: PortalService) {
      this.subscriptionLang = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        // this.sharedService.errorHandling(event, (function(){
          const myLang = this.translate.currentLang;
          if (myLang === 'en') {
             this.lang = 'en';
             this.languageId = 1;
          }
          if (myLang === 'ms') {
            this.lang = 'ms';
            this.languageId = 2;
          }

          if(this.topnavservice.flagLang && this.isInitialized){
            console.log('flagLang', 'masuk');
            this.subscription = this.getData(this.languageId);
            //this.submitPoll('');
            this.pollDataAnswer = JSON.parse(localStorage.getItem('getPollResult'))
            console.log(JSON.parse(localStorage.getItem('getPollResult')));
          }
      });

      this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
        this.fontSize = data;
      });

      this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
        this.fontType = data;
      });
    }

    ngOnInit() {


    if (!this.languageId) {
        if (localStorage.getItem('langID')) {
            this.languageId = localStorage.getItem('langID');
        } else { 
            this.languageId = 1;
        }
      }
      this.subscription = this.getData(this.languageId);    

        // this.getUserIpAddr();
    }

    ngAfterViewInit() {
      this.getTheme();
      this.sharedService.loadFontSizeData();
      this.sharedService.loadFontTypeData();
    }

    ngOnDestroy() {
      this.subscriptionLang.unsubscribe();
      this.subscription.unsubscribe();
      this.subscriptionFontSize.unsubscribe();
      this.subscriptionFontType.unsubscribe();
    }

   getData(languageId) {
         return this.http.get(this.config.urlPoll + '/question/lang/' + languageId + '/?active=true')
          .map(res => res.json())
          .subscribe(eventData => {
            this.sharedService.errorHandling(eventData, (function(){
                //console.log(eventData)
                this.lengthPoll = eventData.pollQuestionListDto.length;
                console.log(this.lengthPoll);
                if(this.lengthPoll != 0 ){
                    let resData = eventData.pollQuestionListDto[0];
                    this.pollDataQuestion = resData.questionTitle;
                    //console.log("POLL Non: "+ this.pollDataQuestion);
                    this.pollDataAnswer = resData.answer.filter(fData => fData.answer !== undefined);
                    this.pollDataQuestionID = resData.questionId;
                    this.pollReference = resData.pollReference;
                    // tslint:disable-next-line:radix
                    // if (!this.latestResult) { // Check Latest Result Message while change lang
                        // this.showResult = ((localStorage.getItem('polldone') === resData.pollReference.toString()));
                    // }

                    if(this.pollReference == localStorage.getItem('polldone')){ // bila poll dah buat
                        this.pollDataAnswer = JSON.parse(localStorage.getItem('getPollResult'))
                        this.closeResult();
                    }
                }
                // this.pollDataComment = eventData[0].comment;
                this.generatePercentageData();
                setTimeout(()=>{
                  this.isInitialized = true;
                }, 500);
                
              }).bind(this));
            }, error => {
              this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
          }
          );
    }

    getAnsData() {
        // return this.http.get('http://10.1.17.12:3000/pollresult')
        //   .map(res => res.json())
        //  .subscribe(eventData => {
        //        this.pollAnswer = eventData[0].answer;
        //        // this.pollDataComment = eventData[0].comment;
        //    });
   }

    getTheme() {
        //console.log(localStorage.getItem('themeColor'));
        
        return localStorage.getItem('themeColor');

        
    }
    
    getThemeName() {
        document.documentElement.style.setProperty('--progressbar-background', localStorage.getItem('themeColor'));
        return localStorage.getItem('themeName');
    }

    changeProgressBarCss(){

    }

    onSelectionChange(selItem) {
        console.log(selItem);
        // this.sharedService.showSuccess(selItem.answer);
        this.pollAnswer = selItem;
    }

    submitPoll(event) {
        if (!this.pollAnswer)  {
            this.sharedService.showError(this.translate.instant('poll.err.noanswer'), '');
            return;
        }
        
        const data = {
            'pollsComment': this.pollComment,
            'pollsAnswerId' : this.pollAnswer.id,
            'pollsQuestionId': this.pollDataQuestionID
            // 'pollReference' : this.pollReference
            };
        this.portalservice.submitPoll(data)
        .subscribe(
            resData => {
                this.sharedService.errorHandling(resData, (function(){
                  this.resultData = resData;
                  this.pollDataAnswer = resData.answer;
                  //console.log("LEPAS SUBMIT: ")
                  //console.log(this.pollDataAnswer)
                  this.pollDataQuestion = resData.questionTitle;
                  this.pollDataQuestionID = resData.questionId;
                  this.pollReference = resData.pollReference;

                //   if(this.flagSend == false){
                    /*this.sharedService.showSuccess(
                        `<div><strong>${this.translate.instant('poll.respon')} :</strong> ${this.pollComment}</div>
                        <div><strong>${this.translate.instant('poll.answer')} :</strong> ${this.pollAnswer.answer}</div>`,'',{closeButton:true, timeOut:4000, progressBar:true, enableHtml:true}
                    )*/
                    this.sharedService.showSuccess(this.translate.instant('poll.success'));
                    localStorage.setItem('getPollResult', JSON.stringify(this.pollDataAnswer));
                //   }
                //   this.flagSend = true;
                this.pollComment = null;
                this.pollAnswer = null;
                this.generatePercentageData();
                  
                }).bind(this));
            }, Error => {
                this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
            }
        );

      //  this.sharedService.showSuccess('Recommendation is : ' + this.pollComment + ', Answer is ' + this.pollAnswer.answer);
        this.showResult = true;
        // localStorage.setItem('polldone', this.pollReference);
    }

    closeResult() {
        this.latestResult = true;
        this.showResult = false;
    }
    ShowLatest() {
        this.latestResult = false;
        this.showResult = true;
    }
    // getUserIpAddr() {
    //     this.sharedService.getIpCliente()
    //     .subscribe(resData => {
    //       this.ipData = resData.text();
    //     },
    //     Error => {
    //      this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
    //    });
    // }

    generatePercentageData() {
        this.pollDataSet = [];
        let dataSet = [];
        let isPoolAnswered =  false;

        this.pollDataAnswer.forEach((pollAnswer) => {
          //console.log('pollAnswer', pollAnswer);
          let pollPercent = 0;
          let poll = { "answer": 0, "percent" : 0}
          let numerator;
          let denomi;
          if (pollAnswer.result) {
            numerator = parseInt(pollAnswer.result.split('/')[0]);
            denomi = parseInt(pollAnswer.result.split('/')[1]);
          } else {
            pollAnswer.result = 0;
          }
          if (numerator && denomi) {
            pollPercent  = (numerator / denomi) * 100;
          } else {
            pollPercent  = 0;
          }
          poll.answer = pollAnswer.answer;
          poll.percent = pollPercent;

          if (poll.percent > 0) {
            isPoolAnswered = true;
          } 
          //console.log(pollAnswer.result);
          this.pollDataSet.push(poll);
          dataSet.push(pollPercent);
        });
        if (isPoolAnswered) {
          let adjustedPercent = this.func(dataSet, 100);
          for (let i =0; i < adjustedPercent.length; i ++) {
            this.pollDataSet[i].percent = adjustedPercent[i];
          }
        }
      }

      func( orig, target ) {
        var i = orig.length, j = 0, total = 0, change, newVals = [], next, factor1, factor2, len = orig.length, marginOfErrors = [];
        // map original values to new array
        while( i-- ) {
            total += newVals[i] = Math.round( orig[i] );
        }
        change = total < target ? 1 : -1;
        while( total !== target ) {
            // Iterate through values and select the one that once changed will introduce
            // the least margin of error in terms of itself. e.g. Incrementing 10 by 1
            // would mean an error of 10% in relation to the value itself.
            for( i = 0; i < len; i++ ) {
                next = i === len - 1 ? 0 : i + 1;
                factor2 = errorFactor( orig[next], newVals[next] + change );
                factor1 = errorFactor( orig[i], newVals[i] + change );
                if(  factor1 > factor2 ) {
                    j = next; 
                }
            }
            newVals[j] += change;
            total += change;
        }
    
        for( i = 0; i < len; i++ ) { marginOfErrors[i] = newVals[i] && Math.abs( orig[i] - newVals[i] ) / orig[i]; }
    
          for( i = 0; i < len; i++ ) {
              for( j = 0; j < len; j++ ) {
                  if( j === i ) continue;
    
                  var roundUpFactor = errorFactor( orig[i], newVals[i] + 1)  + errorFactor( orig[j], newVals[j] - 1 );
                  var roundDownFactor = errorFactor( orig[i], newVals[i] - 1) + errorFactor( orig[j], newVals[j] + 1 );
                  var sumMargin = marginOfErrors[i] + marginOfErrors[j];
    
                  if( roundUpFactor < sumMargin) { 
                      newVals[i] = newVals[i] + 1;
                      newVals[j] = newVals[j] - 1;
                      marginOfErrors[i] = newVals[i] && Math.abs( orig[i] - newVals[i] ) / orig[i];
                      marginOfErrors[j] = newVals[j] && Math.abs( orig[j] - newVals[j] ) / orig[j];
                  }
                  if( roundDownFactor < sumMargin ) { 
                      newVals[i] = newVals[i] - 1;
                      newVals[j] = newVals[j] + 1;
                      marginOfErrors[i] = newVals[i] && Math.abs( orig[i] - newVals[i] ) / orig[i];
                      marginOfErrors[j] = newVals[j] && Math.abs( orig[j] - newVals[j] ) / orig[j];
                  }
              }
          }
          function errorFactor( oldNum, newNum ) {
              return Math.abs( oldNum - newNum ) / oldNum;
          }
          return newVals;
    }
    
    
    getPercentage(index) {
        let percent = 0;
        // console.log(this.pollDataSet[index]);
       if (this.pollDataSet[index]) {
        percent = this.pollDataSet[index].percent;
       } 
       this.progressbarVal = percent;
       return this.progressbarVal;
    }

    calVal(val) {
        if (val) {
            // tslint:disable-next-line:radix
        const numerator = parseInt(val.split('/')[0]);
        // tslint:disable-next-line:radix
        const denomi = parseInt(val.split('/')[1]);
        // tslint:disable-next-line:radix
        if (numerator && denomi) {
            this.pollPercent  = (numerator / denomi) * 100;
        }else {
            this.pollPercent  = 0;
        }
        this.progressbarVal = Math.round(this.pollPercent);
        // 
        return this.progressbarVal;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/poll/poll.component.ts